import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as htmlHelper from "../../helpers/html"

class TravelGuideStep4 extends Component {
  getTravelFormTranslation(option) {
    const { config } = this.props
    let translation = ""
    const formattedOption = option.toLowerCase().replace(/\s/g, "")
    switch (formattedOption) {
      case "bus":
        translation = config.transportToAirportBusOptionText || "Bus"
        break
      case "drivenbyanother":
        translation = config.transportToAirportDriveOptionText || "Kørt"
        break
      case "privatecar(ormotercycle,scooter)":
        translation = config.transportToAirportPrivateCarOptionText || "Privat bil (eller motorcykel, knallert)"
        break
      case "flight(transit)":
        translation = config.transportToAirportPlaneOptionText || "Fly (transit)"
        break
      case "metro":
        translation = config.transportToAirportMetroOptionText || "Metro"
        break
      case "taxi":
        translation = config.transportToAirportTaxiOptionText || "Taxi"
        break
      case "train":
        translation = config.transportToAirportTrainOptionText || "Tog"
        break
      case "other":
        translation = config.transportToAirportOtherOptionText || "Anden"
        break
      default:
        translation = config.doNotKnowText || "Ved det ikke endnu"
        break
    }
    return translation
  }
  render() {
    const { departingFlight, arrivingFlight } = this.props
    const { travelsWithChildren, travelsWithLuggage, travelForm, config } = this.props
    const departingTime = departingFlight && dateHelper.formatDate(departingFlight.ScheduledTime, "HH.mm", "da")
    const departingDate = departingFlight && dateHelper.formatDate(departingFlight.ScheduledTime, "DD.MM.YYYY", "da")
    const arrivingTime = arrivingFlight && dateHelper.formatDate(arrivingFlight.ScheduledTime, "HH.mm", "da")
    const arrivingDate = arrivingFlight && dateHelper.formatDate(arrivingFlight.ScheduledTime, "DD.MM.YYYY", "da")
    return (
      <React.Fragment>
        <div className="flight-header w--narrow style_v2">
          {(config.confirmationSubHeaderText && htmlHelper.htmlStringToReactElement(config.confirmationSubHeaderText)) || (
            <React.Fragment>
              <h3>Din rejse</h3>
              <p className="rich-text">
                Her kan du se din rejse. Vil du ændre i dine rejser eller informationer, kan du gøre det nu. Vi glæder os til at sende dig godt og
                trygt afsted.
              </p>
            </React.Fragment>
          )}
        </div>
        <div className="flights-block deck--grey_v2 style_v2">
          {departingFlight && (
            <div className="flight-tile">
              <div className="title">
                {config.firstTabName || "Afrejse"} {departingFlight.Flight}
              </div>
              <span className="small-text strong">{departingFlight.DestinationName}</span>
              <span className="small-text">
                {departingFlight.CarrierName}, {departingDate} kl. {departingTime}
              </span>
            </div>
          )}
          {arrivingFlight && (
            <div className="flight-tile">
              <div className="title">
                {config.secondTabName || "Hjemrejse"} {arrivingFlight.Flight}
              </div>
              <span className="small-text strong">{arrivingFlight.DestinationName}</span>
              <span className="small-text">
                {arrivingFlight.CarrierName}, {arrivingDate} kl. {arrivingTime}
              </span>
            </div>
          )}
          <div className="flight-options small-text">
            {travelsWithLuggage !== undefined && (
              <div className="flight-option">
                <span className="left">{config.travelWithLuggageText || "Rejser du med indchecket bagage"}:</span>
                <span className="right strong">
                  {travelsWithLuggage
                    ? config.yesText || "Ja"
                    : travelsWithLuggage === null
                      ? config.doNotKnowText || "Ved det ikke endnu"
                      : config.noText || "Nej"}{" "}
                </span>
              </div>
            )}
            {travelForm !== undefined && (
              <div className="flight-option">
                <span className="left">{config.transportToAirportText || "Transport til lufhavnen"}:</span>
                <span className="right strong">{this.getTravelFormTranslation(travelForm)}</span>
              </div>
            )}
            {travelsWithChildren !== undefined && (
              <div className="flight-option">
                <span className="left">{config.travelWithChildrenText || "Rejser du med børn"}:</span>
                <span className="right strong">
                  {travelsWithChildren
                    ? config.yesText || "Ja"
                    : travelsWithChildren === null
                      ? config.doNotKnowText || "Ved det ikke endnu"
                      : config.noText || "Nej"}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="button-container">
          <a
            className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
              config.confirmationCompleteButtonBackgroundColor || "button--general is-blue-text"
            }`}
            href={config.confirmationCompleteButtonUrl}
          >
            <span className="icon">
              <svg className="svg-icon svg-icon--planeduo">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/svg/symbols.svg#svg-planeduo">
                  &nbsp;
                </use>
              </svg>
            </span>
            <span className="text strong">{config.confirmationCompleteButtonText || "Forbered dig til rejsen"}</span>
          </a>
        </div>
      </React.Fragment>
    )
  }
}
export default TravelGuideStep4
